import MD5 from 'md5.js';

// md5加密
export function md5(value) {
  return new MD5().update(value).digest('hex');
}